/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import ContentWrapper from 'Component/ContentWrapper';
import { scrollToTop } from 'Util/Browser';
import { lazyComponentLoader } from 'Util/lazyComponentLoader';

import './GdprCookiePage.style';

export const GdprCookiePopup = lazyComponentLoader(
    () => import(
        /* webpackMode: "lazy", webpackChunkName: "gdpr" */
        '@scandipwa/gdpr-cookie/src/component/GdprCookiePopup'
    ), 2
);

export const GdprCookieGroupPopup = lazyComponentLoader(
    () => import(
        /* webpackMode: "lazy", webpackChunkName: "gdpr" */
        '@scandipwa/gdpr-cookie/src/component/GdprCookieGroupPopup'
    ), 2
);
/** @namespace Bodypwa/Route/GdprCookiePage/Component */
export class GdprCookiePageComponent extends PureComponent {
    static propTypes = {
        updateBreadcrumbs: PropTypes.func.isRequired,
        cleanUpTransition: PropTypes.func.isRequired
    };

    componentDidMount() {
        this.updateBreadcrumbs();
        this.cleanUpTransition();
        scrollToTop();
    }

    cleanUpTransition() {
        const { cleanUpTransition } = this.props;

        cleanUpTransition();
    }

    updateBreadcrumbs() {
        const { updateBreadcrumbs } = this.props;
        const breadcrumbs = [
            {
                url: '',
                name: __('Cookie settings')
            }
        ];

        updateBreadcrumbs(breadcrumbs);
    }

    render() {
        return (
            <div block="GdprCookiePage">
                <ContentWrapper
                  wrapperMix={ { block: 'GdprCookiePage', elem: 'Wrapper' } }
                  label="Gdpr cookie page"
                >
                    <GdprCookiePopup isPopUp={ false } />
                    <GdprCookieGroupPopup />
                </ContentWrapper>
            </div>
        );
    }
}

export default GdprCookiePageComponent;
